(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/contains-correct-outcome.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/contains-correct-outcome.js');
"use strict";


const containsCorrectOutcome = (betOutcome, resultOutcome) => {
  if (!Array.isArray(betOutcome) || !Array.isArray(resultOutcome)) {
    return false;
  }
  if (betOutcome.length === 0 || resultOutcome.length === 0) {
    return false;
  }
  return JSON.stringify(betOutcome) === JSON.stringify(resultOutcome);
};
const containsCorrectOutcomeWithHeatmapMaxValue = (betOutcome, resultOutcome, heatmapMaxValue) => {
  if (!heatmapMaxValue) {
    return false;
  }
  if (!Array.isArray(resultOutcome)) {
    return false;
  }
  const modifiedResultOutcome = resultOutcome.map(outcome => {
    if (outcome > heatmapMaxValue) {
      return heatmapMaxValue;
    }
    return outcome;
  });
  return containsCorrectOutcome(betOutcome, modifiedResultOutcome);
};
setGlobal('svs.components.poolBetting.utils', {
  containsCorrectOutcome,
  containsCorrectOutcomeWithHeatmapMaxValue
});

 })(window);